/* BIONIKA - Kollekcio AJAX szuro/navigacio (felepitmenyek-1 tipusu oldalakra)
   A felso kategoria-kartyak al-kollekciokra mutatnak. Kattintaskor a cel-kollekcio
   TERMEK-RACSAT es FACET-SZUROJET toltjuk be AJAX-szal (a product-grid szekcio
   cserejevel), teljes oldalfrissites nelkul. A Dawn facetjei a behuzott tartalomban
   automatikusan ujrainicializalodnak (custom element). */
(function () {
  'use strict';

  function gridSection(root) {
    var pg = (root || document).querySelector('#ProductGridContainer');
    return pg ? pg.closest('.shopify-section') : null;
  }
  var section = gridSection(document);
  if (!section) return;

  // --- Animacio CSS injektalasa (a kijelolt_ kek keret a temaban mar megvan) ---
  (function () {
    var st = document.createElement('style');
    st.textContent =
      '.kategoria{transition:box-shadow .28s ease, transform .28s ease;}' +
      '.kategoria.kijelolt_kategoria{box-shadow:rgb(0,174,255) 0 0 0 2px inset !important;animation:bnkPop .32s ease;}' +
      '.alkategoriaLeiras a.kijelolt_alkategoria{display:inline-block;padding:1px 7px;border-radius:8px;box-shadow:rgb(0,174,255) 0 0 0 2px inset !important;transition:box-shadow .28s ease;animation:bnkPop .32s ease;}' +
      '@keyframes bnkPop{0%{transform:scale(.9)}55%{transform:scale(1.04)}100%{transform:scale(1)}}' +
      // marka kereso + show more/less
      'fieldset.facets-wrap.bnk-open li.show-more-item,fieldset.facets-wrap.bnk-searching li.show-more-item{display:list-item !important;}' +
      'fieldset.facets-wrap li.facets__item.bnk-nomatch{display:none !important;}' +
      '.bnk-showmore-btn{display:inline-block;margin:.6rem 0 0;padding:.2rem 0;background:none;border:none;cursor:pointer;color:rgb(0,160,226);font-size:1.3rem;font-weight:600;}' +
      '.bnk-showmore-btn:hover{text-decoration:underline;}' +
      'fieldset.facets-wrap.bnk-searching .bnk-showmore-btn{display:none;}' +
      'show-more-button{display:none !important;}';
    document.head.appendChild(st);
  })();

  function handleOf(href) { var m = (href || '').match(/\/collections\/([a-z0-9\-]+)/); return m ? m[1] : null; }
  function currentHandle() { var m = location.pathname.match(/\/collections\/([a-z0-9\-]+)/); return m ? m[1] : null; }

  // Az aktualis kollekciohoz tartozo kategoria/alkategoria kiemelese
  function markActive() {
    var cur = currentHandle();
    document.querySelectorAll('.kijelolt_kategoria').forEach(function (e) { e.classList.remove('kijelolt_kategoria'); });
    document.querySelectorAll('.kijelolt_alkategoria').forEach(function (e) { e.classList.remove('kijelolt_alkategoria'); });
    if (!cur) return;
    document.querySelectorAll('.kategoria > a[href]').forEach(function (a) {
      if (handleOf(a.getAttribute('href')) === cur) { var k = a.closest('.kategoria'); if (k) k.classList.add('kijelolt_kategoria'); }
    });
    document.querySelectorAll('.alkategoriaLeiras a[href]').forEach(function (a) {
      if (handleOf(a.getAttribute('href')) === cur) {
        a.classList.add('kijelolt_alkategoria');
        var k = a.closest('.kategoria'); if (k) k.classList.add('kijelolt_kategoria');
      }
    });
  }

  // === Marka kereso (a regi torott markaSearch felulirasa) ===
  window.markaSearch = function () {
    var inp = document.querySelector('#marka-search'); if (!inp) return;
    var fs = inp.closest('fieldset'); if (!fs) return;
    var words = inp.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
    fs.classList.toggle('bnk-searching', words.length > 0);
    fs.querySelectorAll('li.facets__item').forEach(function (li) {
      if (!words.length) { li.classList.remove('bnk-nomatch'); return; }
      var txt = (li.textContent || '').toLowerCase();
      li.classList.toggle('bnk-nomatch', !words.every(function (w) { return txt.indexOf(w) >= 0; }));
    });
  };

  // === Show more / less gomb (a rejtett show-more-item markak kinyitasahoz) ===
  function initShowMore() {
    document.querySelectorAll('fieldset.facets-wrap').forEach(function (fs) {
      if (fs.querySelector('.bnk-showmore-btn')) return;
      var hidden = fs.querySelectorAll('li.show-more-item').length;
      if (!hidden) return;
      var ul = fs.querySelector('ul.no-js-hidden') || fs.querySelector('ul');
      if (!ul) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bnk-showmore-btn';
      var more = 'Több (' + hidden + ') ▾', less = 'Kevesebb ▴';
      btn.textContent = more;
      btn.addEventListener('click', function () {
        btn.textContent = fs.classList.toggle('bnk-open') ? less : more;
      });
      ul.parentNode.insertBefore(btn, ul.nextSibling);
    });
  }
  function initFilters() { window.markaSearch(); initShowMore(); updateEmptyBrandNote(); }

  // === Ures talalati lista + aktiv globalis marka: figyelmezteto kartya ===
  // A liquid rejtve rendereli (0 talalatnal a Shopify filter.active_values ures,
  // ezert szerver-oldalon nem detektalhato a marka-szuro); itt mutatjuk meg, ha az
  // URL-ben compatibility parameter van, es kitoltjuk a markanevet.
  function updateEmptyBrandNote() {
    var note = document.querySelector('[data-bnk-empty-brand-note]');
    if (!note) return;
    if (location.search.indexOf('compatibility') === -1) { note.hidden = true; return; }
    var brand = '';
    try {
      var b = window.BionikaBrand && window.BionikaBrand.get && window.BionikaBrand.get();
      if (typeof b === 'string') brand = b;
      else if (b) brand = b.name || b.label || b.brand || '';
    } catch (err) {}
    if (!brand) {
      try {
        new URL(location.href).searchParams.forEach(function (v, k) {
          if (!brand && k.indexOf('compatibility') !== -1 && v !== 'BIONIKA') brand = v;
        });
      } catch (err) {}
    }
    var nameEl = note.querySelector('[data-bnk-brand-name]');
    if (nameEl) nameEl.textContent = brand ? ' (' + brand + ')' : '';
    note.hidden = false;
  }


  function setLoading(on) {
    section.style.opacity = on ? '0.5' : '';
    section.style.pointerEvents = on ? 'none' : '';
  }

  function load(url, push) {
    setLoading(true);
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = gridSection(doc);
        if (fresh) {
          section.innerHTML = fresh.innerHTML;
          if (doc.title) document.title = doc.title;
        } else {
          window.location.href = url; return;
        }
        if (push !== false) history.pushState({ bnkajax: 1 }, '', url);
        markActive();
        initFilters();
        setLoading(false);
      })
      .catch(function () { setLoading(false); window.location.href = url; });
  }

  // Kattintas-elkapas: kategoria-kartyak + lapozas + aktiv-szuro chipek (NEM a termek-linkek)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="/collections/"]');
    if (!a) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    // termek-kartya linkjeit hagyjuk normalisan mukodni
    if (a.closest('.card-wrapper, .card, product-card') && a.closest('#ProductGridContainer')) return;
    // csak: kategoria-kartyak (.kategoria / .alkategoriaLeiras), lapozas, aktiv szuro eltavolitas
    var ok = a.closest('.kategoria') ||
             a.closest('.pagination, nav.pagination, .pagination-wrapper') ||
             a.closest('.active-facets');
    if (!ok) return;
    e.preventDefault();
    load(a.href, true);
  });

  window.addEventListener('popstate', function () { load(location.href, false); });

  // "Marka-kijeloles torlese" gomb az ures talalati listan: elfelejti a globalis
  // markat (BionikaBrand.clear), es a compatibility parameterek nelkul tolti ujra
  // az oldalt. Delegalt listener: tuleli a grid/facet ujrarenderelest.
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-bnk-clear-brand]') : null;
    if (!b) return;
    e.preventDefault();
    try { if (window.BionikaBrand && window.BionikaBrand.clear) window.BionikaBrand.clear(); } catch (err) {}
    var url = new URL(location.href);
    var del = [];
    url.searchParams.forEach(function (v, k) { if (k.indexOf('compatibility') !== -1) del.push(k); });
    del.forEach(function (k) { url.searchParams.delete(k); });
    location.href = url.toString();
  });


  // Kezdeti kiemeles + szuro-init (oldal betoltesekor)
  // A section referenciat is frissitjuk: PJAX-csere utan a regi DOM-node mar arva.
  function bnkInit() { section = gridSection(document) || section; markActive(); initFilters(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bnkInit); } else { bnkInit(); }
  // PJAX-navigacio (pjax-nav.liquid) utan ujra kell epiteni a Tobb/Kevesebb gombot es a
  // marka-keresot: a szuro DOM-ja kicserelodott, a gombokat pedig ez a script szurja be.
  document.addEventListener('bionika:content-swapped', bnkInit);
  // A Dawn facet-AJAX-a es a brand-context reapply is UJRARENDERELI a szurosavot
  // (a content-swapped UTAN is!), ami kidobja a beszurt gombot. Orszem: ha van rejtett
  // marka-elem, de nincs gomb, potoljuk. A setTimeout-os osszevonas vedi a rekurziot
  // (a gomb beszurasa maga is mutacio).
  if (window.MutationObserver) {
    var moPending = false;
    new MutationObserver(function () {
      if (moPending) return;
      moPending = true;
      setTimeout(function () {
        moPending = false;
        var needSm = document.querySelector('li.show-more-item') && !document.querySelector('.bnk-showmore-btn');
        var note = document.querySelector('[data-bnk-empty-brand-note]');
        var needNote = note && note.hidden && location.search.indexOf('compatibility') !== -1;
        if (needSm || needNote) bnkInit();
      }, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
